namespace RedBullMOBILE360.BulkSMS {
    export interface BulkSMSRow {
        Id?: number;
        SmsContent?: string;
        SmsDate?: string;
        SmsType?: number;
        SmsStatus?: number;
    }

    export namespace BulkSMSRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SmsContent';
        export const localTextPrefix = 'BulkSMS.BulkSMS';
        export const deletePermission = 'BulkSMS';
        export const insertPermission = 'BulkSMS';
        export const readPermission = 'BulkSMS';
        export const updatePermission = 'BulkSMS';

        export declare const enum Fields {
            Id = "Id",
            SmsContent = "SmsContent",
            SmsDate = "SmsDate",
            SmsType = "SmsType",
            SmsStatus = "SmsStatus"
        }
    }
}
